import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getBeachCleaningList,
	addNewBeachCleaning,
	updateBeachCleaning,
	deleteBeachCleaning,
	getBeachCleaning,
	getBeachCleaningData,
	registerBeachCleaning
} from '../beachCleaning/thunk';

export const initialState = {
	itemBeachCleaningList: [],
	itemBeachCleaning: null,
	isBeachCleaningLoading: false,
	isBeachCleaningSuccess: false,

	statusBeachCleaningList: [],

	dataBeachCleaning: null,
	beachCleaningList: [],
	beachCleaningListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
    isLoaded: false,
    isError: false,
    error: null,
    folderPaths: [],
};

const BeachCleaningSlice = createSlice({
	name: 'BeachCleanings',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireReloadSelectionItemsGrid(state, action) {
			state.requireReloadSelectionItemsGrid = action.payload;
		},
		cleanDataBeachCleaning(state, action) {
			state.dataBeachCleaning = null;
		},
		restartRegisterBeachCleaning(state, action) {
			state.isAdding = false;
			state.isAdded = false;
			state.registerDisabled = false;
		},
		restartStatement(state, action) {
			state.isStatementing = false;
			state.isStatemented = false;
			state.isStatementError = false;
		},
	},
	extraReducers: builder => {
		builder.addCase(getBeachCleaning.fulfilled, (state, action) => {
			state.isBeachCleaningLoading = false;
			state.isBeachCleaningSuccess = true;
			state.itemBeachCleaning = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getBeachCleaning.pending, state => {
			state.isBeachCleaningLoading = true;
			state.isBeachCleaningSuccess = null;
			state.itemBeachCleaning = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getBeachCleaning.rejected, (state, action) => {
			state.isBeachCleaningLoading = false;
			state.isBeachCleaningSuccess = false;
			state.itemBeachCleaning = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getBeachCleaningList.pending, state => {
			state.isBeachCleaningSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getBeachCleaningList.fulfilled, (state, action) => {
			state.itemBeachCleaningList = action.payload;
			state.beachCleaningList = action.payload;
			state.isLoadingList = false;
			state.isBeachCleaningSuccess = true;

			let beachCleaningListSelect = [];
			action.payload.map(item =>
				beachCleaningListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.beachCleaningListSelect = beachCleaningListSelect;
		});
		builder.addCase(getBeachCleaningList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isBeachCleaningSuccess = true;
		});
		builder.addCase(addNewBeachCleaning.fulfilled, (state, action) => {
			state.itemBeachCleaningList.push(action.payload);
			state.beachCleaningList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewBeachCleaning.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewBeachCleaning.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateBeachCleaning.fulfilled, (state, action) => {
			state.itemBeachCleaningList = state.itemBeachCleaningList.map(beachCleaning =>
				beachCleaning.beachCleaningname === action.payload.old_beachCleaning
					? { ...beachCleaning, ...action.payload.updated_beachCleaning }
					: beachCleaning
			);
			state.beachCleaningList = state.beachCleaningList.map(beachCleaning =>
				beachCleaning._id.toString() === action.payload._id.toString()
					? { ...beachCleaning, ...action.payload }
					: beachCleaning
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateBeachCleaning.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateBeachCleaning.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteBeachCleaning.fulfilled, (state, action) => {
			state.itemBeachCleaningList = current(state.itemBeachCleaningList).filter(
				item => item._id !== action.payload._id
			);
			state.beachCleaningList = current(state.beachCleaningList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteBeachCleaning.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteBeachCleaning.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		builder.addCase(getBeachCleaningData.fulfilled, (state, action) => {
			state.isBeachCleaningLoading = false;
			state.isBeachCleaningSuccess = true;
			state.dataBeachCleaning = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getBeachCleaningData.pending, state => {
			state.dataBeachCleaning = null
			state.isBeachCleaningLoading = true;
			state.isBeachCleaningSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getBeachCleaningData.rejected, (state, action) => {
			state.dataBeachCleaning = null
			state.isBeachCleaningLoading = false;
			state.isBeachCleaningSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(registerBeachCleaning.fulfilled, (state, action) => {
			state.registerDisabled = true;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
		});
		builder.addCase(registerBeachCleaning.pending, state => {
			state.registerDisabled = false;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(registerBeachCleaning.rejected, (state, action) => {
			state.registerDisabled = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
			state.requireCloseModal = true;
			state.error = action.error.message;
		});
	},
});

export const {
	setRequireCloseModal,
	setRequireReloadSelectionItemsGrid,
	cleanDataBeachCleaning,
	restartRegisterBeachCleaning,
	restartStatement
} = BeachCleaningSlice.actions;

export default BeachCleaningSlice.reducer;
